import type { WithChildren } from '@ab-core/utils/types';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const Portal: FC<WithChildren> = (props) => {
    const { children } = props;
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);

        return () => setMounted(false);
    }, []);

    if (!mounted || typeof document === 'undefined') {
        return null;
    }

    return createPortal(children, document.body);
};

export default Portal;
